import "../stylesheets/App.css";
import "../stylesheets/DashboardAdmin.css";
import React, { useEffect, useMemo, useState } from "react";
import HeaderHome from "./subcomponents/HeaderHome.js";
import AdminUserModule from "./subcomponents/AdminUserModule.js";
import AdminStageModule from "./subcomponents/AdminStageModule.js";
import Loader from "./subcomponents/Loader.js";
import { useNavigate } from "react-router-dom";

function DashboardAdmin() {
  const [loadingIsAdmin, setLoadingIsAdmin] = useState(true);
  const [moduleActive, setModuleActive] = useState("users");
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  const userInfo = useMemo(() => {
    try {
      const raw = localStorage.getItem("user-info");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  useEffect(() => {
    // 1) Si no está logueado o el flag local dice que no es admin => afuera
    if (!userInfo || userInfo.is_admin == 0) {
      navigate("/", { replace: true });
      return;
    }

    // 2) Validación real contra backend (por si el localStorage está “tocado”)
    const checkIsAdmin = async () => {
      try {
        const resp = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/admin/is-admin/${userInfo.idUser}`
        );
        const data = await resp.json();

        const ok = !!data?.data;
        setIsAdmin(ok);
        setLoadingIsAdmin(false);

        if (!ok) navigate("/", { replace: true });
      } catch (err) {
        console.log(err);
        setLoadingIsAdmin(false);
        navigate("/", { replace: true });
      }
    };

    checkIsAdmin();

    // 3) Ajustes de UI (con null-checks para no romper)
    const htmlRef = document.getElementById("html-ref");
    if (htmlRef) htmlRef.style.overflowY = "auto";

    const searchContainer = document.getElementById("search-container-home");
    if (searchContainer) searchContainer.style.display = "none";
  }, [navigate, userInfo]);

  const background1 = {
    backgroundImage:
      "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(" +
      process.env.PUBLIC_URL +
      "/images/stage_banners/bg-usuarios-admin.webp)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: "white",
  };

  const background2 = {
    backgroundImage:
      "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(" +
      process.env.PUBLIC_URL +
      "/images/stage_banners/bg-fases-admin.webp)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: "white",
  };

  // Si todavía está validando, mostramos loader (igual que antes)
  // (y evitamos renderizar módulos si no es admin)
  if (loadingIsAdmin) {
    return (
      <>
        <HeaderHome is_admin={true} />
        <Loader />
      </>
    );
  }

  if (!isAdmin) return null;

  return (
    <>
      <HeaderHome is_admin={true} />

      <section className="admin-modules-section">
        <div className="div-modules-container">
          <div
            className={moduleActive === "users" ? "modules-btn active" : "modules-btn"}
            style={background1}
            onClick={() => setModuleActive("users")}
          >
            Módulo
            <br />
            Usuarios
          </div>

          <div
            className={moduleActive === "stages" ? "modules-btn active" : "modules-btn"}
            style={background2}
            onClick={() => setModuleActive("stages")}
          >
            Módulo
            <br />
            gestión de Fases
          </div>
        </div>
      </section>

      {moduleActive === "users" ? <AdminUserModule /> : <AdminStageModule />}
    </>
  );
}

export default DashboardAdmin;
